(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('myboard', {
            parent: 'app',
            url: '/my-board',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'MyBoard'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/myboard/myboard.html',
                    controller: 'MyBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    $translatePartialLoader.addPart('tipoHora');
                    $translatePartialLoader.addPart('complexidadeChamado');
                    $translatePartialLoader.addPart('situacaoSprint');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
